export class SpectrumData {
  freq: number;
  power: number;
}
